import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import debug from 'Helper/debugHelpers'
import { useDispatch } from 'react-redux'
import { markWindowMessageReceived, markAllWindowMessageReceived, sendWindowMessage as sendWindowMessageAction } from 'actions/windowMessagingActions'

const withMessaging = (priv, privOperator) => {
  return WrappedComponent => {
    const WithMessaging = props => {
      const dispatch = useDispatch()
      const { windowMessages, windowConfig, ...rest } = props

      const receiveWindowMessage = useCallback(() => {
        if (windowConfig && windowConfig.ref && windowMessages && windowMessages.length > 0) {
          const message = windowMessages[0]
          debug.logObject(
            windowConfig.ref + ' receiving message',
            message,
            debug.logLevels.WINDOW_MESSAGE
          )
          dispatch(markWindowMessageReceived(windowConfig.ref))
          return message
        }
      }, [windowMessages, windowConfig?.ref])

      const receiveAllMessages = useCallback(() => {
        if (windowConfig && windowConfig.ref && windowMessages && windowMessages.length > 0) {
          const messages = [...windowMessages]
          debug.logObject(
            windowConfig.ref + ' receiving all messages',
            messages,
            debug.logLevels.WINDOW_MESSAGE
          )
          dispatch(markAllWindowMessageReceived(windowConfig.ref))
          return messages
        }
      }, [windowMessages, windowConfig?.ref])

      const sendWindowMessage = useCallback((recipient, payload, config = {}) => {
        debug.logObject(
          windowConfig?.ref + ' sending message',
          { recipient, payload, config },
          debug.logLevels.WINDOW_MESSAGE
        )
        dispatch(sendWindowMessageAction(
          recipient,
          payload,
          windowConfig?.ref,
          config
        ))
      }, [windowConfig?.ref])

      return (
        <WrappedComponent
          {...rest}
          windowConfig={windowConfig}
          windowMessagesWaiting={windowMessages && windowMessages.length > 0}
          receiveWindowMessage={receiveWindowMessage}
          receiveAllWindowMessages={receiveAllMessages}
          sendWindowMessage={sendWindowMessage}
        />
      )
    }
    return WithMessaging
  }
}

export default withMessaging

withMessaging.propTypes = {
  // WindowConfig passed in by WindowContainer
  windowConfig: PropTypes.object.isRequired
}
